// react-quill components
import ReactQuill from "react-quill-new";

// react-quill styles
import "react-quill/dist/quill.snow.css";
import "./style.css";

// Custom styles for the SoftEditor
import SoftEditorRoot from "components/SoftEditor/SoftEditorRoot";

function SoftEditor({ onChange, ...props }) {
  const handleChange = (value) => {
    const div = document.createElement("div");
    div.innerHTML = value;
    const links = div.querySelectorAll("a");
    links.forEach((link) => {
      let href = link.getAttribute("href");
      if (href && !href.startsWith("http://") && !href.startsWith("https://")) {
        link.setAttribute("href", `http://${href}`);
      }
    });
    if (onChange) {
      onChange(div.innerHTML);
    }
  };

  return (
    <SoftEditorRoot>
      <ReactQuill theme="snow" {...props} onChange={handleChange} />
    </SoftEditorRoot>
  );
}

export default SoftEditor;
